import { render, staticRenderFns } from "./NormalSearchNav254.vue?vue&type=template&id=654e92fa&scoped=true"
import script from "./NormalSearchNav254.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav254.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e92fa",
  null
  
)

export default component.exports